<template>
    <div class="kanban-container" ref="kanban">
        <div style="height:50px;display:flex;" class="prod-kanban-header">
            <img style="height:30px;margin: 15px 70px 15px 90px;" :src="require('../../assets/p-kb-1.png')" />
            <span>【{{ companyName }}】品质看板</span>
            <img style="height:30px;margin-top:15px;margin-left: 75px;" :src="require('../../assets/p-kb-1.png')" />
        </div>

        <div class="quality-kanban-header" style="display:flex">
            <div>今日巡检：<span>{{ todayPatrolCount }}</span></div>
            <div>巡检正常：<span>{{ todayPatrolCount - todayAbnormalCount }}</span></div>
            <div>巡检异常：<span>{{ todayAbnormalCount }}</span></div>
        </div>

        <div style="overflow: auto;height: 500px;">
            <table class="kanban-table">
                <tr>
                    <td style="width: 15px;max-width: 15px;">巡检点</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 35px;max-width: 35px;">最近异常情况</td>
                </tr>

                <tr v-for="(item, index) in productionKanbanList" :key="index">

                    <td>{{ item.patrolPointName }}</td>

                    <td>{{ item.createdTimeOne }}</td>
                    <td>{{ item.makerOne }}</td>
                    <td>{{ item.statusOne }}</td>

                    <td>{{ item.createdTimeTwo }}</td>
                    <td>{{ item.makerTwo }}</td>
                    <td>{{ item.statusTwo }}</td>

                    <td>{{ item.createdTimeThree }}</td>
                    <td>{{ item.makerThree }}</td>
                    <td>{{ item.statusThree }}</td>

                    <td>{{ item.createdTimeFour }}</td>
                    <td>{{ item.makerFour }}</td>
                    <td>{{ item.statusFour }}</td>

                    <td>{{ item.abnCondition }}</td>
                </tr>

            </table>

            <div style="height: 10px;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div style="height: 10px;"></div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyId: '',
            companyName: '中国制造',

            todayPatrolCount: 0,
            todayAbnormalCount: 0,

            productionKanbanList: [],

            index: 0,
            statusSearch: 0,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getInfo() {
            this.$axios({
                method: "post",
                url: "/shiro/patrol/record/getInfo",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.todayPatrolCount = data.data.todayPatrolCount
                this.todayAbnormalCount = data.data.todayAbnormalCount
            })
        },
        getAll() {

            this.$axios({
                method: "get",
                url: "/shiro/quality/kanban/tv?companyId=" + this.companyId + '&pageIndex=' + this.pageIndex,
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                this.productionKanbanList = data.data

                this.total = this.productionKanbanList[0].total

                // console.log('aaaaaaaaa')
                // console.log(parseInt(this.total / 18) * 18)

                if (this.pageIndex == (parseInt(this.total / 18) * 18)) {

                    this.pageIndex = 0
                } else {
                    this.pageIndex = parseInt(this.pageIndex) + 18
                }

                for (let i in this.productionKanbanList) {

                    var pkbl = this.productionKanbanList[i]

                    if (pkbl.createdTimeOne) {
                        pkbl.createdTimeOne = this.$moment(pkbl.createdTimeOne).format("MM-DD HH:mm")
                    }

                    if (pkbl.createdTimeTwo) {
                        pkbl.createdTimeTwo = this.$moment(pkbl.createdTimeTwo).format("MM-DD HH:mm")
                    }

                    if (pkbl.createdTimeThree) {
                        pkbl.createdTimeThree = this.$moment(pkbl.createdTimeThree).format("MM-DD HH:mm")
                    }

                    if (pkbl.createdTimeFour) {
                        pkbl.createdTimeFour = this.$moment(pkbl.createdTimeFour).format("MM-DD HH:mm")
                    }

                    pkbl.statusOne = pkbl.statusOne == null ? '' : pkbl.statusOne == 0 ? '异常' : '正常'

                    pkbl.statusTwo = pkbl.statusTwo == null ? '' : pkbl.statusTwo == 0 ? '异常' : '正常'

                    pkbl.statusThree = pkbl.statusThree == null ? '' : pkbl.statusThree == 0 ? '异常' : '正常'

                    pkbl.statusFour = pkbl.statusFour == null ? '' : pkbl.statusFour == 0 ? '异常' : '正常'
                }

            })
        },
        toFloat3(val) {
            // console.log('toFloat2')
            // console.log(val.toFixed(3))
            // console.log(val.toFixed(3) * 100)
            if (isNaN(val)) {
                val = 0
            }

            return parseFloat((val.toFixed(3) * 100).toFixed(10))
        },
        fullScreen() {
            // console.log('fullScreen')
            let element = this.$refs.kanban
            // console.log(element)

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        pageClick(currentPage) {
            this.purchaseKanbanList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {

        let url = window.location.href
        // console.log('url')
        // console.log(url)

        let str = url.substring(url.indexOf('?') + 1);
        let arrs = str.split('&');
        let result = {};

        arrs.forEach(item => {
            let keyArr = item.split('=');
            let name = keyArr[0];
            let value = keyArr[1];
            result[name] = value;
        })

        // console.log('result')
        // console.log(result)

        if (Object.keys(result).length >= 1) {
            // console.log(result)
            // console.log('result.cid')
            // console.log(result.cid)
            this.companyId = result.cid
            this.pageIndex = result.p
        }

        this.timer = setInterval(() => {
            this.getInfo()

            this.getAll()
        }, 20000)

        this.$axios({
            method: "post",
            url: "/shiro/company/getKb",
            data: {
                id: this.companyId
            },
            headers: {}
        }).then(result => {
            this.companyName = result.data.data.companyName
        })

    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 545px;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.prod-kanban-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 50px;
}

.quality-kanban-header {
    background-color: lightblue;
    color: #06207D;
    margin: 5px;
    font-size: 14px;
}

.quality-kanban-header>div {
    width: 33%;
    height: 40px;
    line-height: 40px;
}

.quality-kanban-header span {
    font-size: 28px;
}

.quality-kanban-header span:nth-child(3) {
    color: red;
}

.kanban-table {
    width: 950px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 15px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
}

.kanban-tr-odd {
    font-size: 11px;
    color: black;
    background-color: white;
}

.kanban-tr {
    font-size: 11px;
    color: black;
    background-color: greenyellow;
}

.kanban-table td {
    border: 1px solid white;
}

.kanban-tr-odd td,
.kanban-tr td {
    border: 1px solid black;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;
}

.el-pagination__total {
    color: pink;
}
</style>